import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const dataStreamResolver: FieldResolver = (metadata: Metadata) =>
  ({
    dataStream: !isEmpty(metadata.getDataStreams()) ? metadata.getDataStreams()![0] : undefined
  } as StreamData)

export default dataStreamResolver
